import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

/**
 * Set to `true` in a request's `HttpContext` to exclude that specific request
 * from the global loading indicator (e.g. silent background list refreshes
 * that should not block the UI with a full-screen spinner).
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

/**
 * Drives the single, application-wide loading indicator (`app-loading-spinner`,
 * shown in the app root — see `App`) for every outgoing HTTP request.
 *
 * `finalize()` guarantees `hide()` runs on success, error, or unsubscription
 * alike, so the loader can never get stuck visible.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  loaderService.show();
  return next(req).pipe(
    finalize(() => loaderService.hide()),
  );
};

